import { render, staticRenderFns } from "./InspectionDrawerStats.vue?vue&type=template&id=f39ef2dc&"
import script from "./InspectionDrawerStats.vue?vue&type=script&lang=js&"
export * from "./InspectionDrawerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports